module.exports = {
  reactStrictMode: false,
  productionBrowserSourceMaps: true,
  i18n: {
    defaultLocale: 'es',
    locales: ['de', 'fr', 'es'],
    localeDetection: false,
  },
  turbopack: {
    root: __dirname,
  },
};
